import DataTable from './DataTable';
export * from './DataTable';
export default DataTable;